import PropTypes from 'prop-types';
import { useSnackbar } from "notistack";
import DeleteIcon from '@material-ui/icons/Delete';
import { Tooltip, Button } from "@material-ui/core";
import React, { useState, useRef, Fragment } from "react";

import api from "../../../../../services/api.js";

export default function Del(props) {
    const snack = useRef()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar
    const closeSnackbarRef = useRef()
    closeSnackbarRef.current = closeSnackbar

    const [id, setId] = useState(null);
    const epaeId = useRef()
    epaeId.current = id

    async function DeleteConsultant(key) {
        closeSnackbarRef.current(key)
        api.delete(`/epae/${epaeId.current}`)
            .then(() => {
                props.setReload(currentIsOpen => !currentIsOpen)
                snack.current("ePAE excluído", { variant: 'success' })
            })
            .catch((error) => {
                console.log(error);
                snack.current("Falha ao excluir ePAE", { variant: 'error' })
            })
    }

    const action = key => (
        <Fragment>
            <Button onClick={() => { DeleteConsultant(key) }}>
                Sim
            </Button>
            <Button onClick={() => { closeSnackbarRef.current(key) }}>
                Não
            </Button>
        </Fragment>
    );

    function confirmationWindow(nome) {
        snack.current(`Deseja exluir ePAE?`, {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            variant: 'info',
            persist: true,
            preventDuplicate: true,
            action,
        })
    }

    return (
        <Tooltip title={<span style={{ fontSize: 15 }}> Excluir </span>} >
            <Button
                onClick={() => {
                    setId(props.data._id)
                    confirmationWindow(props.data.nome)
                }}
                size="small"
            >
                <DeleteIcon />
            </Button>
        </Tooltip>
    );
}

Del.propTypes = {
    data: PropTypes.object,
    setReload: PropTypes.func,
};
